import { makeStyles } from 'tss-react/mui';

const StageCompletionStyles = makeStyles()(() => ({
  grid: {
    width: '100%',
  },
  stageCompletionHeading: {
    margin: '0.625rem 0rem',
  },
  stageCompletionText: {
    margin: '0.625rem 0rem',
  },
  staticPageButtom: {
    marginTop: '1.5625rem',
  },
  journeyContainer: {
    marginBottom: '1rem',
  },
}));

export default StageCompletionStyles;
